import { render, staticRenderFns } from "./allDeal.vue?vue&type=template&id=0e7c1dda&scoped=true"
import script from "./allDeal.vue?vue&type=script&lang=js"
export * from "./allDeal.vue?vue&type=script&lang=js"
import style0 from "./allDeal.vue?vue&type=style&index=0&id=0e7c1dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c1dda",
  null
  
)

export default component.exports